import { Routes, Route, Navigate } from 'react-router-dom';

import Page404 from '@lwtears/lwt-common-frontend/lib/Page404';
import Page500 from '@lwtears/lwt-common-frontend/lib/Page500';

import theme from 'themes/defaultTheme';
import { ErrorPage, MainContainer as Main } from 'components/layout';
import Home from 'components/modules/Home';
import Class from 'components/modules/Class';
import AdminPackets from 'components/modules/AdminPackets';
import HelpAndSupport from 'components/modules/HelpAndSupport';
import ViewAssessmentDetails from 'components/modules/ViewAssessmentDetails';
import ChecklistTable from 'components/modules/ObservationalChecklists';
import StudentSummary from 'components/modules/StudentSummary';
import Assessment from 'components/modules/Assessment';

// import { isQA } from 'config';
// import Sandbox from 'components/layout/Sandbox';
// const registerPageView = (path: string): void => {
//   try {
//     const dataLayer = (window as any).dataLayer || [];
//     dataLayer.push({ event: 'Pageview', pagePath: path });
//   } catch {
//     return;
//   }
// };

const AppRouter: React.FunctionComponent<React.PropsWithChildren> = () => (
  <Routes>
    <Route
      path="/home"
      key="Classes"
      element={
        <Main>
          <Home />
        </Main>
      }
    />
    <Route
      path="/assessments"
      key="Assessment Details"
      element={
        <Main>
          <ViewAssessmentDetails />
        </Main>
      }
    />
    <Route
      path="/studentSummary"
      key="Student Summary"
      element={
        <Main>
          <StudentSummary />
        </Main>
      }
    />
    <Route
      path="/checklist/:id"
      key="Checklist"
      element={
        <Main>
          <ChecklistTable />
        </Main>
      }
    />
    <Route
      path="/class/:id"
      key="Classroom"
      element={
        <Main>
          <Class />
        </Main>
      }
    />
    <Route
      path="/assessment/:id"
      key="Student Assessment"
      element={
        <Main>
          <Assessment />
        </Main>
      }
    />
    <Route
      path="/educatorPackets"
      key="Educator Packets"
      element={
        <Main>
          <AdminPackets />
        </Main>
      }
    />
    <Route
      path="/help"
      key="Help And Support"
      element={
        <Main>
          <HelpAndSupport />
        </Main>
      }
    />
    <Route
      path="/404"
      element={<Page404 theme={theme.palette.secondary.dark} />}
      key="404 Not Found"
    />
    <Route
      path="/oops"
      element={<Page500 color={theme.palette.secondary.dark} />}
      key="500 Internal Server Error"
    />
    <Route path="/error" element={<ErrorPage />} key="Error" />
    <Route path="/*" element={<Navigate to="/home" />} />
  </Routes>
);

export default AppRouter;
